export const VALIDATE_ADDRESS_ERROR = 'validate-address-error';
